import HomePageScreen from './Components/home';
import './App.css';

function App() {
  return (
    <div className="App">
      <HomePageScreen />
    </div>
  );
}

export default App;
